import React from 'react'

export default function ProductsWithExpirationsInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        #content { background-color: whitesmoke; }

        .report-wrapper { border: solid 0.5px lightgrey; }

        .firstpage, .pagebreak { margin-bottom: 25px; }
        .lastpage { margin-bottom: 0; }

        .products-inventory-header { font-weight: bold; }

        #products-list-container {
          font-size: 1rem;
          background-color: white;
          box-sizing: border-box;
          padding: 25px;
        }

        .product-container {
          border-left: solid 0.5px black;
          padding: 5px;
        }

        .product-name-th {
          text-align: left;
          border-bottom: solid 0.5px black;
          border-right: solid 0.5px black;
        }

        .inventory-table {
          width: 100%;
          border-top: solid 0.5px black;
          border-left: solid 0.5px black;
          border-spacing: 0;
        }
        .inventory-table th, td {
          padding: 3px;
        }

        .inventory-table th:nth-child(1), .inventory-table td:nth-child(1) {
          width: 40%;
        }
        .inventory-table th:nth-child(2), .inventory-table td:nth-child(2) {
          width: 30%;
        }
        .inventory-table th:nth-child(3), .inventory-table td:nth-child(3) {
          width: 30%;
        }
      `}
      </style>
    </React.Fragment>
  )
}
